export enum RodzajDokumentu {
  DOWOD_OSOBISTY = 'DOWOD_OSOBISTY',
  PASZPORT = 'PASZPORT',
  INNY = 'INNY',
}

export const RODZAJ_DOKUMENTU_LABELS: Record<RodzajDokumentu, string> = {
  [RodzajDokumentu.DOWOD_OSOBISTY]: 'Dowód osobisty',
  [RodzajDokumentu.PASZPORT]: 'Paszport',
  [RodzajDokumentu.INNY]: 'Inny dokument',
};

export function getDocumentTypeDropdownItems() {
  return Object.entries(RODZAJ_DOKUMENTU_LABELS).map(([key, label]) => ({
    label,
    value: key,
  }));
}
